export enum WeatherGroupTypes {
  Algo = 'algo',
  Display = 'display',
}
